/**
 * Short preview copy for case study cards on the homepage.
 * Full challenge, solution, and results stay on /clients/:id.
 */
export const getCaseStudyHomePreview = (casestudy) => {
  const tag =
    casestudy.homeTag ||
    truncateText(casestudy.subheading, 48) ||
    "Case Study";

  const title =
    casestudy.homeTitle ||
    truncateText(casestudy.name, 72) ||
    "Client Success Story";

  return { tag, title };
};

const truncateText = (text, maxLength) => {
  if (!text || typeof text !== "string") {
    return "";
  }

  const trimmed = text.trim();
  if (trimmed.length <= maxLength) {
    return trimmed;
  }

  return `${trimmed.slice(0, maxLength).trim()}...`;
};
